import axiosClient from "@/libs/axiosClient";

export const lineOptimize = options => {
    return axiosClient.get(
        `/3rd/17ce/lineoptimize?testUrl=${options.testUrl}&sid=${options.sid}`
    );
};

export const getRegionInfo = () => {
    return axiosClient.get(`/3rd/17ce/regioninfo`);
};



// WEBPACK FOOTER //
// ./src/api/3rd/17ce.js